/**
 * Email validációs segédfüggvények.
 * Központi helyen kezeli az email cím validálást és szűrést.
 */

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Ellenőrzi, hogy az érték tartalmaz-e non-ASCII (ékezetes) karaktert. */
export function hasNonAsciiChars(value: string): boolean {
  return value.split('').some((ch: string) => ch.charCodeAt(0) > 127);
}

/** Eltávolítja a non-ASCII karaktereket egy stringből. */
export function stripNonAsciiChars(value: string): string {
  return value.split('').filter((ch: string) => ch.charCodeAt(0) <= 127).join('');
}

/** Ellenőrzi az email formátum helyességét (nem-ASCII + regex). */
export function validateEmailValue(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return '';
  if (hasNonAsciiChars(trimmed)) {
    return 'Ékezetes karakterek nem megengedettek az email címben';
  }
  if (!EMAIL_PATTERN.test(trimmed)) {
    return 'Érvénytelen email cím formátum!';
  }
  return '';
}

/**
 * Angular FormControl validátor email mezőhöz.
 * Használható ReactiveFormsModule-lal (pl. SmallInputMenuComponent).
 */
export function emailFormValidator(control: { value: string | null }): { accented: true } | { invalid: true } | null {
  if (!control.value) return null;
  const value = control.value.trim();
  if (hasNonAsciiChars(value)) {
    return { accented: true };
  }
  if (!EMAIL_PATTERN.test(value)) {
    return { invalid: true };
  }
  return null;
}

/**
 * KeyboardEvent handler: megakadályozza ékezetes karakter bevitelét.
 * Használat: (keydown)="blockAccentedChars($event)"
 */
export function blockAccentedCharsOnKeyDown(event: KeyboardEvent): void {
  const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab', 'Home', 'End', 'Enter', 'Escape'];
  if (allowedKeys.includes(event.key) || event.ctrlKey || event.metaKey) {
    return;
  }
  if (event.key.length === 1 && event.key.charCodeAt(0) > 127) {
    event.preventDefault();
  }
}
